<template>   <transition name="fade">     
<div v-if="isShow" class="toast-wrapper">{{ message }}
</div>   </transition> </template>

<script>
export default {
  name: 'Toast',
  props: {
    message: {
      type: String,
      default: ''
    },
    duration: {
      type: Number,
      default: 3000
    }
  },
  data() {
    return {
      isShow: false
    }
  },
  methods: {
    show() {
      this.isShow = true
      setTimeout(() => {
        this.isShow = false
      }, this.duration)
    }
  }
}
</script>

<style lang="scss">
.toast-wrapper {
  position: fixed;
  top: 50%;
  left: 50%;
  padding: 25px 70px;
  max-width: 300px;
  background: rgba(0, 0, 0, .9);
  border-radius: 12px;
  font-size: 14px;
  color: #fff;
  transform: translate(-50%, -50%);
}
.fade-enter-active {
  animation: fadeIn 0.5s;
}
.fade-leave-active {
  animation: fadeIn 0.5s reverse;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>